import React, { Component } from "react";
import { Header, Heading } from "rsuite";
import Datatable from "./Datatable";
import { Input, InputGroup } from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import { SelectPicker, Button, Divider, toaster, Message } from "rsuite";
import axios from "../../axiosIn";
import moment from "moment/moment";

export class ConsultaRegistrados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      estatus: this.mostrarOpcionDescarga() === 0 ? "VALIDADO" : "Registrados",
      setFiltering: "",
      rows: [],
      disabledBtn: false,
      loading: false,
      loadingExport: false,
      opcionDescarga: this.mostrarOpcionDescarga(),
      dataEstatus:
        this.mostrarOpcionDescarga() === 0
          ? [
              { label: "Validados", value: "VALIDADO" },
              { label: "Sin Validar", value: "SIN VALIDAR" },
              { label: "Rechazados", value: "RECHAZADO" },
              { label: "Descargados", value: "DESCARGADA" },
            ]
          : [{ label: "Registrados", value: "Registrados" }],
    };
    this.validSession();
    this.setState({ opcionDescarga: this.mostrarOpcionDescarga() });
  }

  async loadData() {
    this.setState({ loading: true });
    this.setState({ disabledBtn: true });
    var url = `Registro/GetParticipantes/${this.state.estatus}`;
    await axios
      .get(url)
      .then((res) => {
        this.setState({ loading: false });
        this.setState({ rows: res.data });
        this.setState({ disabledBtn: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.error(err);
        this.setState({ disabledBtn: false });
      });
  }

  async downloadExcel() {
    var url = `Registro/Exportar`;
    this.setState({ loadingExport: true });
    await axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Inscritos.xlsx");
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        this.setState({ loadingExport: false });
      })
      .catch((err) => {
        this.setState({ loadingExport: false });
        console.error(err);
      });
  }

  handleChangeEstat = (e) => {
    this.setState({ estatus: e });
  };

  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  toast(msg, type = "info") {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  }

  validSession() {
    var sessionID = this.getCookie("sessionID");
    var expira = this.getCookie("expira");
    var user = this.getCookie("user");
    var dateIsAfter = moment(new Date()).isAfter(moment(expira));

    if (user === "userCons") {
      this.toast("El usuario no cuenta con el permiso", "warning");
      window.location = `/#/Login/Menu`;
    }

    if (sessionID.length === 0) {
      window.location = `/#/Login`;
      window.location.reload();
    }

    if (expira.length > 0) {
      if (dateIsAfter) {
        window.location = `/#/Login`;
        window.location.reload();
      }
    }
  }

  deleteCookies = () => {
    document.cookie = `sessionID=;`;
    document.cookie = "expira=;";
  };

  cerrarSesion() {
    this.deleteCookies();
    window.location = `/#/Login`;
  }

  mostrarOpcionDescarga = () => {
    var permisos = JSON.parse(localStorage.getItem("auth")).permisos;
    var lenPermisos = permisos != null ? permisos.length : 0;
    var existe = 0;

    for (let index = 0; index < lenPermisos; index++) {
      const element = permisos[index].IdForm;
      if (element === 4) {
        existe = 1;
      }
    }
    this.setState({ opcionDescarga: existe });
    return existe;
  };

  render() {
    const { setFiltering, disabledBtn, loading, estatus, opcionDescarga, loadingExport } =
      this.state;
    this.validSession();
    return (
      <>
        <main className="flex min-h-screen items-center justify-center p-3">
          <Header
            style={{
              backgroundColor: "#f9f7f6",
              height: "auto",
              padding: "20px",
              borderRadius: "15px",
            }}
          >
            <div class="col">
              <Heading>Consulta de Participantes</Heading>
            </div>
          </Header>
          <div className="row">
            <div className="flex min-h-screen items-center justify-center p-4">
              <h6>Filtros de búsqueda</h6>
              <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <InputGroup inside>
                    <Input
                      onChange={(e) => this.setState({ setFiltering: e })}
                      placeholder="Escribe los valores a buscar..."
                      autoFocus
                    />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </div>
                &nbsp;
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <SelectPicker
                    data={this.state.dataEstatus}
                    searchable={false}
                    defaultValue={
                      this.state.opcionDescarga === 0
                        ? "VALIDADO"
                        : "Registrados"
                    }
                    style={{ width: "100%" }}
                    onChange={this.handleChangeEstat}
                    placeholder="Selecciona una opción"
                  />
                </div>
                &nbsp;
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Button
                    appearance="primary"
                    className="w-100"
                    loading={loading}
                    disabled={disabledBtn}
                    onClick={() => this.loadData()}
                  >
                    Buscar
                  </Button>
                </div>
                &nbsp;
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Button
                    appearance="ghost"
                    className="w-100"
                    color="blue"
                    onClick={() => {
                      window.history.go(-1);
                    }}
                  >
                    Regresar a menú
                  </Button>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  {opcionDescarga === 1 ? (
                    <Button
                      appearance="ghost"
                      className="w-100"
                      color="blue"
                      onClick={() => this.downloadExcel()}
                      loading={loadingExport}
                    >
                      Exportar a excel
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="flex min-h-screen items-center justify-center p-4">
              <Datatable
                rows={this.state.rows}
                filtering={setFiltering}
                estatusInsc={this.state.estatus}
              />
            </div>
          </div>
          <Divider style={{ fontSize: "11px" }}>Designed by RADYXXA</Divider>
        </main>
      </>
    );
  }
}
